import { requests } from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/reObjectFunctionType/create', params),
	update                : (params) => requests.post('/reObjectFunctionType/update', params),
	delete                : (params) => requests.getWithParams('/reObjectFunctionType/delete', params),
	restore               : (params) => requests.getWithParams('/reObjectFunctionType/restore', params),
	getPaged              : (params) => requests.getWithParams('/reObjectFunctionType/getPaged', params),
	getPagedAll           : (params) => requests.getWithParams('/reObjectFunctionType/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/reObjectFunctionType/getPagedAudit', params),
	getList               : (params) => requests.getWithParams('/reObjectFunctionType/getList', params),
	getObjFuncTypes		  : (params) => requests.getWithParams('/reObjectFunctionType/getObjFuncTypes', params),
}